module.exports = __webpack_public_path__ + "static/sabah-ddaa8896218362de62f03e45eba1414d.png";